import { render, staticRenderFns } from "./PayinDetailsModal.vue?vue&type=template&id=f21fe040&scoped=true"
import script from "./PayinDetailsModal.vue?vue&type=script&lang=js"
export * from "./PayinDetailsModal.vue?vue&type=script&lang=js"
import style1 from "./PayinDetailsModal.vue?vue&type=style&index=1&id=f21fe040&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21fe040",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f21fe040')) {
      api.createRecord('f21fe040', component.options)
    } else {
      api.reload('f21fe040', component.options)
    }
    module.hot.accept("./PayinDetailsModal.vue?vue&type=template&id=f21fe040&scoped=true", function () {
      api.rerender('f21fe040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/customer-service/components/Modal/PayinDetailsModal.vue"
export default component.exports